import React from 'react';
import type { Emotion } from '@/types/analysis';

interface EmotionCardProps {
  emotions: Emotion[];
}

const emotionColors: Record<string, string> = {
  joy: 'bg-yellow-500',
  sadness: 'bg-blue-500',
  anger: 'bg-red-500',
  fear: 'bg-purple-500',
  surprise: 'bg-pink-500',
  disgust: 'bg-green-500',
  trust: 'bg-teal-500',
  anticipation: 'bg-orange-500',
};

const getEmotionColor = (emotion: string): string => {
  const lowerEmotion = emotion.toLowerCase();
  return emotionColors[lowerEmotion] || 'bg-gray-500';
};

export const EmotionCard: React.FC<EmotionCardProps> = ({ emotions }) => {
  // Get top 3 emotions sorted by score
  const topEmotions = [...emotions]
    .sort((a, b) => b.score - a.score)
    .slice(0, 3);

  const primaryEmotion = topEmotions[0];

  return (
    <div className="bg-gray-50 p-4 rounded-lg border border-gray-200">
      <div className="flex items-center justify-between mb-2">
        <h4 className="text-sm font-medium text-gray-700">Emotion Detection</h4>
        <span className="material-symbols-outlined text-2xl text-yellow-500">
          mood
        </span>
      </div>
      <div className="space-y-2">
        {topEmotions.map((emotion, index) => {
          const percentage = Math.round(emotion.score * 100);
          return (
            <div key={index}>
              <div className="flex justify-between text-xs mb-1">
                <span className="font-medium text-gray-700 capitalize">
                  {emotion.emotion}
                </span>
                <span className="text-gray-500">{percentage}%</span>
              </div>
              <div className="w-full bg-gray-200 rounded-full h-2">
                <div
                  className={`h-2 rounded-full ${getEmotionColor(emotion.emotion)} transition-all duration-500`}
                  style={{ width: `${percentage}%` }}
                />
              </div>
            </div>
          );
        })}
      </div>
      {primaryEmotion && (
        <p className="mt-2 text-sm font-medium text-gray-800">
          Primary: <span className="capitalize">{primaryEmotion.emotion}</span>
        </p>
      )}
    </div>
  );
};

